<div class="d-flex flex-column align-items-center mt-100">
  <span class="text-onback-high t-5">خوش آمدید!</span>
  <span class="text-onback-medium b-1 mb-big">شماره موبایل خود را وارد کنید.</span>

  <div
    [formGroup]="form"
    class="h-80 w-100"
  >
    <ui-form-field
      formControlName="phoneNumber"
      [label]="'شماره موبایل'"
      [inputType]="'text'"
      [isNumericKeyboard]="true"
      [maxSize]="11"
      [convertNonEnglishDigits]="true"
      [error]="form.controls['phoneNumber'].errors"
      [errorMessageMapper]="{
        invalidCellNumber: 'شماره موبایل وارد شده معتبر نیست',
      }"
      (keydown)="checkKeyCode($event)"
    ></ui-form-field>
  </div>
  <div class="mt-big mb-minus w-100">
    <ngx-button
      [mode]="'form'"
      [size]="'large'"
      [style]="'fill'"
      [fullWidth]="true"
      [disabled]="form.controls['phoneNumber'].invalid"
      (click)="getCode()"
    >
      قبول شرایط و ادامه
    </ngx-button>
  </div>

  <div class="d-flex flex-wrap justify-content-space-between">
    @if (presentativeCode()) {
      <div class="d-flex gap-tiny text-onback-brand">
        <span>کد معرف: </span>
        <span>{{ presentativeCode() }}</span>
      </div>
      <span></span>
    } @else {
      <ngx-button
        id="referral-button-in-login"
        [mode]="'form'"
        [size]="'small'"
        [style]="'link'"
        (click)="goToStep(LoginState.REPRESENTATIVE)"
      >
        کد معرف دارید؟
      </ngx-button>
    }

    <ngx-button
      id="rules-button-in-login"
      [mode]="'form'"
      [size]="'small'"
      [style]="'link'"
      (click)="goToStep(LoginState.RULES)"
    >
      شرایط استفاده از دیجی‌پی
    </ngx-button>
  </div>
</div>
